export default {
	factoryList_({ factoryList }) {
		return factoryList;
	},
	factoryCd_({ searchParams: { comm } }) {
		return comm.ref1Cd;
	},
	lineList_({ searchParams, lineList }) {
		const {
			comm: { cdDesc }
		} = searchParams;
		let result = lineList.filter(line => line.ref1Cd.includes(ref1Cd));
		return cdDesc ? result : [];
	},
	lineFilteredList_({ searchParams, lineFilteredList }) {
		const {
			comm: { cdDesc }
		} = searchParams;
		return cdDesc ? lineFilteredList : [];
	},
	/** test data */
	resultObj_({ resultObj }) {
		return resultObj;
	},
	resultFileList_({ resultFileList }) {
		return resultFileList;
	},

	//상태값
	getIsSaveFlag_({ isSaveFlag }) {
		return isSaveFlag;
	},

	//saveDataObj3 값
	getSaveDataObj3_({ saveDataObj3 }) {
		return saveDataObj3;
	}
};
